import { styled } from "@mui/material/styles";
import MuiDrawer, { drawerClasses } from "@mui/material/Drawer";
import { MenuContent } from "./MenuContent";
import { useSideMenuExpanded } from "hooks/useSideMenu";
import {
  DRAWER_WIDTH,
  DRAWER_WIDTH_COLLAPSED,
} from "src/store/slices/sideMenuSlice";
import { ExpandSideMenuButton } from "./ExpandSideMenuButton";
import { Stack } from "@mui/material";

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "expanded",
})<{ expanded: boolean }>(({ expanded }) => ({
  width: expanded ? DRAWER_WIDTH : DRAWER_WIDTH_COLLAPSED,
  flexShrink: 0,
  boxSizing: "border-box",
  mt: 10,
  transition: "width 0.3s ease",
  [`& .${drawerClasses.paper}`]: {
    width: expanded ? DRAWER_WIDTH : DRAWER_WIDTH_COLLAPSED,
    boxSizing: "border-box",
    transition: "width 0.3s ease",
    overflowX: "hidden",
  },
}));

export const SideMenu = () => {
  const { isExpanded } = useSideMenuExpanded();

  return (
    <Drawer
      variant="permanent"
      expanded={isExpanded}
      sx={{
        display: { xs: "none", md: "block" },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: "background.paper",
        },
      }}
    >
      <Stack
        sx={{
          overflow: "hidden",
          height: "100%",
          pt: 8,
        }}
      >
        <ExpandSideMenuButton />

        <MenuContent collapsed={!isExpanded} />
      </Stack>
    </Drawer>
  );
};
